import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';
const ZoomMeetingEmbed = loadable(() => import(/* webpackChunkName: "ZoomMeetingEmbedPage" */ '../containers/ZoomMeetingEmbed/ZoomMeetingEmbed'));

const pageDataLoadingAPI = getPageDataLoadingAPI();

// Prefetch critical pages for better performance
const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const BankDetailsPage = loadable(() => import(/* webpackChunkName: "BankDetailsPage" */ '../containers/BankDetailsPage/BankDetailsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ '../containers/SearchPage/SearchPageWithMap'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));
const NoAccessPage = loadable(() => import(/* webpackChunkName: "NoAccessPage" */ '../containers/NoAccessPage/NoAccessPage'));
const PreviewSubmitPage = loadable(() => import(/* webpackChunkName: "PreviewSubmitPage" */ '../containers/PreviewSubmitPage/PreviewSubmitPage'));
const SubscriptionPlan = loadable(() => import(/* webpackChunkName: "SubscriptionPlan" */ '../containers/SubscriptionPlan/SubscriptionPlan'));
// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));
const AdminPanel = loadable(() => import(/* webpackChunkName: "AdminPanel" */ '../containers/AdminPanel/AdminPanel'));
const AdminWithdrawalsPage = loadable(() => import(/* webpackChunkName: "AdminWithdrawalsPage" */ '../containers/AdminWithdrawals/AdminWithdrawalsPage'));
const AdminReferralsPage = loadable(() => import(/* webpackChunkName: "AdminReferralsPage" */ '../containers/AdminReferrals/AdminReferralsPage'));
const AdminLearningPage = loadable(() => import(/* webpackChunkName: "AdminLearningPage" */ '../containers/AdminLearningPage/AdminLearningPage'));
const WalletPage = loadable(() => import(/* webpackChunkName: "WalletPage" */ '../containers/WalletPage/WalletPage'));
const RewardPage = loadable(() => import(/* webpackChunkName: "RewardPage" */ '../containers/RewardPage/RewardPage'));
const FaqPage = loadable(() => import(/* webpackChunkName: "FaqPage" */ '../containers/FaqPage/FaqPage'));
const BlogMainPage = loadable(() => import(/* webpackChunkName: "BlogMainPage" */ '../containers/BlogMainPage/BlogMainPage'));
const BlogAricle = loadable(() => import(/* webpackChunkName: "BlogAricle" */ '../containers/BlogMainPage/BlogAricle/BlogAricle'));
const MyLessonsPage = loadable(() => import(/* webpackChunkName: "MyLessonsPage" */ '../containers/MyLessonsPage/MyLessonsPage'));
const MyProgressPage = loadable(() => import(/* webpackChunkName: "MyProgressPage" */ '../containers/MyProgressPage/MyProgressPage'));
const FamilyDashboardPage = loadable(() => import(/* webpackChunkName: "FamilyDashboardPage" */ '../containers/FamilyDashboardPage/FamilyDashboardPage'));
const ArabibiSitePage = loadable(() => import(/* webpackChunkName: "ArabibiSitePage" */ '../containers/ArabibiSitePage/ArabibiSitePage'));
const AdminLandingPage = loadable(() => import(/* webpackChunkName: "AdminLandingPage" */ '../containers/AdminLandingPage/AdminLandingPage'));

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  // 'StripePayoutPage',
  'PaymentMethodsPage',
  'BankDetailsPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';
const draftBlog = 'blog';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig, accessControlConfig) => {
  const SearchPage = SearchPageWithMap;
  const ListingPage = layoutConfig.listingPage?.variantType === 'carousel'
    ? ListingPageCarousel
    : ListingPageCoverPhoto;

  const isPrivateMarketplace = accessControlConfig?.marketplace?.private === true;
  const authForPrivateMarketplace = isPrivateMarketplace ? { auth: true } : {};

  return [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/ar-home',
      name: 'LandingPageArabic',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/new-home',
      name: 'ArabibiNewHomePage',
      component: ArabibiSitePage,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    // NOTE: when the private marketplace feature is enabled, the '/s' route is disallowed by the robots.txt resource.
    // If you add new routes that start with '/s*' (e.g. /support), you should add them to the robotsPrivateMarketplace.txt file.
    {
      path: '/s',
      name: 'SearchPage',
      ...authForPrivateMarketplace,
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/s/:listingType',
      name: 'SearchPageWithListingType',
      ...authForPrivateMarketplace,
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/zoom/meeting/:transactionId/:meetingNumber',
      name: 'ZoomMeetingEmbedPage',
      auth: true,
      authPage: 'LoginPage',
      component: ZoomMeetingEmbed,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    // Inserted before the generic ":variant" route so it doesn't get shadowed
    {
      path: '/l/:slug/:id/preview-submit',
      name: 'PreviewSubmitPage',
      auth: true,
      authPage: 'LoginPage',
      component: PreviewSubmitPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/blog/new',
      name: 'NewBlogsPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftBlog, id: draftId, type: 'new', tab: 'blog-details' }}
        />
      ),
    },
    {
      path: '/blog/:slug/:id',
      name: 'BlogArticlePage',
      ...authForPrivateMarketplace,
      component: BlogAricle,
      loadData: pageDataLoadingAPI.BlogArticlePage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/preview-submit',
      name: 'PreviewSubmitPage',
      auth: true,
      authPage: 'LoginPage',
      component: PreviewSubmitPage,
      // Reuse EditListingPage loader to fetch listing data
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/users',
      name: 'AdminPanel',
      auth: true,
      authPage: 'LoginPage',
      component: AdminPanel,
      loadData: pageDataLoadingAPI.AdminPage.loadData,
    },
    {
      path: '/admin/withdrawals',
      name: 'AdminWithdrawals',
      auth: true,
      authPage: 'LoginPage',
      component: AdminWithdrawalsPage,
      loadData: pageDataLoadingAPI.AdminWithdrawalsPage.loadData,
    },
    {
      path: '/admin/referrals',
      name: 'AdminReferrals',
      auth: true,
      authPage: 'LoginPage',
      component: AdminReferralsPage,
      loadData: pageDataLoadingAPI.AdminReferralsPage.loadData,
    },
    {
      path: '/admin/learning',
      name: 'AdminLearningPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminLearningPage,
      loadData: pageDataLoadingAPI.AdminLearningPage.loadData,
    },
    {
      path: '/admin/landing-page',
      name: 'AdminLandingPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      ...authForPrivateMarketplace,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:id/:variant',
      name: 'ProfilePageVariant',
      auth: true,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings/:tab',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup/:userType',
      name: 'SignupForUserTypePage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/bank-details',
      name: 'BankDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: BankDetailsPage,
    },
    {
      path: '/wallet',
      name: 'WalletRedirectPage',
      component: () => <NamedRedirect name="WalletPage" />,
    },
    {
      path: '/wallet-info',
      name: 'WalletInfoRedirectPage',
      component: () => <NamedRedirect name="FaqPage" search="?tab=payment-wallet" />,
    },
    {
      path: '/wallet/my-wallet',
      name: 'WalletPage',
      auth: true,
      authPage: 'LoginPage',
      component: WalletPage,
      loadData: pageDataLoadingAPI.WalletPage.loadData,
    },
    {
      path: '/rewards',
      name: 'RewardPage',
      auth: true,
      authPage: 'LoginPage',
      component: RewardPage,
      loadData: pageDataLoadingAPI.RewardPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/no-:missingAccessRight',
      name: 'NoAccessPage',
      component: NoAccessPage,
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/subscription-plan',
      name: 'SubscriptionPlan',
      component: SubscriptionPlan,
      loadData: pageDataLoadingAPI.SubscriptionPlanPage.loadData,
    },
    {
      path: '/faq',
      name: 'FaqPage',
      component: FaqPage,
    },
    {
      path: '/blog',
      name: 'BlogMainPage',
      component: BlogMainPage,
      loadData: pageDataLoadingAPI.BlogMainPage.loadData,
    },
    {
      path: '/my-lessons',
      name: 'MyLessonsPage',
      auth: true,
      authPage: 'LoginPage',
      component: MyLessonsPage,
      loadData: pageDataLoadingAPI.MyLessonsPage.loadData,
    },
    {
      path: '/my-progress',
      name: 'MyProgressPage',
      auth: true,
      authPage: 'LoginPage',
      component: MyProgressPage,
      loadData: pageDataLoadingAPI.MyProgressPage.loadData,
    },
    {
      path: '/account/family',
      name: 'FamilyDashboardPage',
      auth: true,
      authPage: 'LoginPage',
      component: FamilyDashboardPage,
      loadData: pageDataLoadingAPI.FamilyDashboardPage.loadData,
    },
    {
      path: '/signup/child',
      name: 'ChildRegistrationPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup', isChildAutoCheck: true },
    },
  ];
};

export default routeConfiguration;
